import { configureStore } from '@reduxjs/toolkit';
import fileReducer from './slices/fileslice';
import alertReducer from './slices/alertslice';
import { useDispatch, useSelector } from "react-redux";
export const store = configureStore({
    reducer: {
        file: fileReducer,
        alert: alertReducer
    },
});
store.subscribe(() => {
    const state = store.getState();
    localStorage.setItem("rea-download-favorites", JSON.stringify(state.file.favorites));
    localStorage.setItem("rea-alerts-dismissed", JSON.stringify(state.alert.dismissed));
});
export const useAppDispatch = useDispatch;
export const useAppSelector = useSelector;
